
import { Badge } from '@/components/ui/badge';
import { formatFilterValue } from '../utils/filterUtils';

interface ActiveFiltersProps {
  climate: string | null;
  hasBeach: boolean | null;
  safety: string | null;
  region: string | null;
  onRemoveFilter: (filter: string, value: null) => void;
  onClearAll: () => void;
}

export const ActiveFilters = ({
  climate,
  hasBeach,
  safety,
  region,
  onRemoveFilter,
  onClearAll
}: ActiveFiltersProps) => {
  if (!climate && hasBeach === null && !safety && !region) return null;

  return (
    <div className="border-t pt-4 mt-4">
      <div className="flex flex-wrap gap-2 mb-3">
        {climate && (
          <Badge variant="secondary" className="gap-1">
            Climate: {formatFilterValue(climate)}
            <button 
              onClick={() => onRemoveFilter('climate', null)}
              className="ml-1 hover:text-destructive"
            >
              ×
            </button>
          </Badge>
        )}
        {hasBeach && (
          <Badge variant="secondary" className="gap-1">
            Beach Destinations
            <button 
              onClick={() => onRemoveFilter('hasBeach', null)}
              className="ml-1 hover:text-destructive"
            >
              ×
            </button>
          </Badge>
        )}
        {safety && (
          <Badge variant="secondary" className="gap-1">
            Safety: {safety}
            <button 
              onClick={() => onRemoveFilter('safety', null)}
              className="ml-1 hover:text-destructive"
            >
              ×
            </button>
          </Badge>
        )}
        {region && (
          <Badge variant="secondary" className="gap-1">
            Region: {formatFilterValue(region)}
            <button 
              onClick={() => onRemoveFilter('region', null)}
              className="ml-1 hover:text-destructive"
            >
              ×
            </button>
          </Badge>
        )}
      </div>
      <button
        onClick={onClearAll}
        className="text-sm text-primary hover:text-primary/80 transition-colors"
      >
        Clear all filters
      </button>
    </div>
  );
};
